import { Box, BoxProps, ColorOptions, Form, Icon, ModBox, Spacer, Text } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { isEmpty } from '@jfs/utils'
import { useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { formData } from './formData'
import { liabilityFormData } from './liabilityFormData'

const FormBox = ({ children }: any) => {
  return <Box w={360}>{children}</Box>
}

const MerchantConfig = () => {
  const [searchText, setSearchText] = useState('')
  const [selectedMid, setSelectedMid] = useState('')
  const {
    fetchMidPayoutConfig,
    fetchMidPayoutLiabilityConfig,
    updateMidPayoutConfig,
    getAllConfigs,
    accessConfig,
    getLiabilityConfig,
    updateLiabilityConfig,
    frequencies,
    fetchPayoutFrequencyConfig,
    searchMid,
  } = useStores((store) => ({
    fetchMidPayoutConfig: store.merchantPayoutConfig.fetchMidPayoutConfig,
    fetchMidPayoutLiabilityConfig: store.merchantPayoutConfig.fetchMidPayoutLiabilityConfig,
    updateMidPayoutConfig: store.merchantPayoutConfig.updateMidPayoutConfig,
    updateLiabilityConfig: store.merchantPayoutConfig.updateMidPayoutLiabilityConfig,
    getAllConfigs: store.merchantPayoutConfig.getAllConfigs,
    getLiabilityConfig: store.merchantPayoutConfig.getLiabilityConfig,
    config: store.user.accessConfig,
    accessConfig: store.user.getAccessConfig(['payout_config']),
    frequencies: store?.payoutFrequencyConfig?.getAllFrequencies(),
    fetchPayoutFrequencyConfig: store.payoutFrequencyConfig.fetchPayoutFrequencyConfig,
    searchMid: store.searchMid,
  }))

  const [lazyFetchMidPayoutLiaibilityConfig, { state: liabilityApiState, data: liabilityApiData }] =
    useLazyApiData(fetchMidPayoutLiabilityConfig)
  const [lazyFetchMidPayoutConfig, { state, data: apiData }] = useLazyApiData(fetchMidPayoutConfig)
  const [lazyUpdateMidPayoutConfig, { state: updateState }] = useLazyApiData(updateMidPayoutConfig)
  const [lazyUpdateLiabilityConfig, { state: updateLiabilityStateState }] = useLazyApiData(updateLiabilityConfig)
  const [lazyFetchPayoutFrequencyConfig] = useLazyApiData(fetchPayoutFrequencyConfig)

  const [isAdd, setIsAdd] = useState(false)
  const [hideForms, setHideForms] = useState(true)

  useEffect(() => {
    setHideForms(true)
  }, [searchText])
  useEffect(() => {
    if (state === 'fulfilled') {
      setHideForms(false)
      lazyFetchPayoutFrequencyConfig()
    } else if (state === 'rejected' && apiData?.message === 'Payout configuration details not found') {
      setHideForms(false)
      setIsAdd(true)
    }
  }, [state])
  const [lazyFetchSearchMidApi, { state: searchMidState }] = useLazyApiData(searchMid)

  useEffect(() => {
    if (searchMidState === 'fulfilled') {
      isAccessible(accessConfig, 'fetch') && lazyFetchMidPayoutConfig(searchText)
      isAccessible(accessConfig, 'fetch') && lazyFetchMidPayoutLiaibilityConfig(searchText)
    }
  }, [searchMidState])
  const handleOnPress = () => {
    setIsAdd(false)
    setSelectedMid(searchText)
    lazyFetchSearchMidApi(searchText, 'Entity ID', 'checkEntityPresence')
  }
  const data = getAllConfigs()
  const liabilityConfigs = getLiabilityConfig()

  const renderActionButton = ({ values, isValid }) => {
    const updatedData = {
      ...values,
    }
    return (
      <ButtonNew
        title={'Save Payout Configs'}
        onPress={() => lazyUpdateMidPayoutConfig(searchText, updatedData, isAdd)}
        height={36}
        disabled={!(isValid && (state === 'fulfilled' || isAdd))}
        hide={!isAccessible(accessConfig, 'add')}
        isLoading={updateState === 'pending'}
      />
    )
  }

  const renderLiabilityActionButton = ({ values, isValid }) => {
    return (
      <ButtonNew
        title={'Save Liability Configs'}
        onPress={() => lazyUpdateLiabilityConfig(searchText, values)}
        height={36}
        disabled={!(isValid || !values?.allowLiability)}
        hide={!isAccessible(accessConfig, 'add')}
        isLoading={updateLiabilityStateState === 'pending'}
      />
    )
  }

  useEffect(() => {
    if (updateLiabilityStateState === 'fulfilled') {
      isAccessible(accessConfig, 'fetch') && lazyFetchMidPayoutLiaibilityConfig(searchText)
    }
  }, [updateLiabilityStateState])

  const showErrComp = state === 'rejected' && searchMidState !== 'fulfilled' && liabilityApiState === 'rejected'
  return (
    <Box {...styles.container}>
      <Text title={'Search & Update'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Spacer size={24} direction="vertical" />
      <Box flexDirection={'row'}>
        <TextInputNew
          value={searchText}
          onChange={setSearchText}
          placeholder={'Search MID/ Entity ID'}
          type={'body12'}
          maxLength={15}
          borderColor={'DISABLED_GREY'}
          borderRadius={4}
          padding={8}
          leftComponent={<Icon id={'SEARCH'} color={'PRIMARY_GREY'} size={14} />}
        />
        <Spacer size={16} direction="horizontal" />
        <ButtonNew
          onPress={handleOnPress}
          title={'Search'}
          height={36}
          disabled={searchText.length < 15}
          isLoading={state === 'pending' || searchMidState === 'pending' || liabilityApiState === 'pending'}
        />
      </Box>
      <Spacer size={24} direction="vertical" />
      <ModBox show={!hideForms}>
        <Text
          title={selectedMid}
          fontFamily={'jiotype-bold'}
          fontSize={16}
          color={'BLACK_21'}
          hide={isEmpty(selectedMid) || state !== 'fulfilled'}
        />
        <Spacer size={24} direction="vertical" />
        <ModBox show={showErrComp} f={1} align={'center'} justify={'center'}>
          <Text
            title={apiData?.message || liabilityApiData?.message}
            fontFamily={'jiotype-bold'}
            fontSize={16}
            color={'BLACK_21'}
          />
        </ModBox>
        {!!selectedMid && (state === 'fulfilled' || isAdd) && (
          <Form
            formData={formData(isAccessible(accessConfig, 'add'), frequencies)}
            container={FormBox}
            actionButtons={renderActionButton}
            initialValues={data}
          />
        )}
        <ModBox marginVertical={24} h={1} bg={'BLACK_75'} show={!!selectedMid && liabilityApiState === 'fulfilled'} />
        {!!selectedMid && liabilityApiState === 'fulfilled' && (
          <Text
            title={'Merchant Payout Liability Config'}
            fontSize={24}
            fontFamily={'jiotype-medium'}
            color={'#5a5c69' as ColorOptions}
          />
        )}
        <Spacer size={16} direction="vertical" />
        {!!selectedMid && liabilityApiState === 'fulfilled' && (
          <Form
            formData={liabilityFormData(isAccessible(accessConfig, 'add'))}
            container={FormBox}
            actionButtons={renderLiabilityActionButton}
            initialValues={liabilityConfigs}
          />
        )}
      </ModBox>
    </Box>
  )
}

const styles = {
  container: {
    h: '100%',
    bg: 'WHITE',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    overflow: 'auto',
    p: 16,
  } as BoxProps,
}
export default MerchantConfig
